import { urlBackendUsuarios } from "../core/configs/config";
import HttpService from '../services/HttpService';
import { format } from "date-fns";


const axiosClient = HttpService.getAxiosClient();

const epName = "/indice/";
const epFuenteName = "/fuente/";
const epTipoValorName = "/tipo_valor/";
const epHistorialName = "/indice_historial/";
const epHistorialCompletoName = "/indice_historial_completo/";
const nameItemsText = "Indices";
const nameItemText = "Indice";
const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// ############################################################################# 
//
export const getIndices = async (params) => {
    let _params = {};
    let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

    if (params) {
        if (params.descripcion) {
            _params.descripcion = params.descripcion;
        }
        if (params.codigo) {
            _params.codigo = params.codigo;
        }
        if (params.mes) {
            _params.mes = params.mes;
        }
        if (params.anio) {
            _params.anio = params.anio;
        }
        if (params.tipoValor && params.tipoValor !== "todo") {
            _params.tipo_valor = params.tipoValor;
        }
        if (params.tipoFecha && params.tipoFecha !== "todo") {
            _params.tipo_fecha = params.tipoFecha;
        }
        if (params.fechaDesde) {
            _params.fecha_desde = format(params.fechaDesde, 'yyyy/MM/dd');
        }

        if (params.fechaHasta) {
            _params.fecha_hasta = format(params.fechaHasta, 'yyyy/MM/dd');
        }

        if (params.estado) {
            let estado =
                params.estado === "habilitado"
                    ? "H"
                    : params.estado === "deshabilitado"
                        ? "D"
                        : "";
            _params.habilitado = estado;
        }

        if (params.rows) {
            _params.rows = params.rows;
        }

        if (params.first) {
            _params.first = params.first;
        }

        if (params.sortField) {
            _params.sortfield = params.sortField;
        }

        if (params.sortOrder) {
            _params.sortorder = params.sortOrder;
        }

    }

    try {
        const response = await axiosClient.get(`${urlBackendUsuarios}${epName}`, {
            params: _params,
            headers: {
                "Access-Control-Allow-Origin": "*",
            },
        });

        if (response.status === 200) {
            let _error = "error_code" in response.data;
            if (!_error) {
                // si no hay error controlado
                response.ok = true;
                return response;
            }
        }

        // si hay algun error controlado

        console.log(_errorMessage);
        console.log(response);

        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "error";
        return response;
    } catch (error) {
        console.log(_errorMessage);
        if (error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            console.log(error.response);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log(error);
        }
        let response = {};
        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "error";
        return response;
    }

};
//
// #############################################################################
//
export const getIndice = async (params) => {
    let _errorMessage = `Se produjo un error al obtener ${elLa} ${nameItemText}`;

    try {
        const response = await axiosClient.get(`${urlBackendUsuarios}${epName}`, {
            params: params,
            headers: {
                "Access-Control-Allow-Origin": "*",
            },
        });

        if (response.status === 200) {
            let _error = "error_code" in response.data;
            if (!_error) {
                // si no hay error controlado
                response.ok = true;
                return response;
            }
        }

        // si hay algun error controlado

        console.log(_errorMessage);
        console.log(response);

        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "error";
        return response;
    } catch (error) {
        console.log(_errorMessage);
        if (error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            console.log(error.response);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log(error);
        }
        let response = {};
        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "error";
        return response;
    }
};
//
// ############################################################################# 
//
export const saveIndice = async (actionCrud, item) => {
    let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;

    const historialItem = {
        valor: item.valor,
        fecha: item.fecha || null,
        vigencia_desde: item.vigencia_desde || null,
        vigencia_hasta: item.vigencia_hasta || null,
        referencia: item.referencia || "",
        resolucion: item.resolucion || "",
        metadata: item.metadata || null,
        fuente_id: item.fuente_id || null,
    };

    let _item = {
        codigo: item.codigo,
        descripcion: item.descripcion,
        tipo_valor: item.tipo_valor,
        tipo_fecha: item.tipo_fecha,
        username_actualiza: item.usernameUsuarioActualiza,
        habilitado: item.habilitado,
        historial: [historialItem],
    };
    if (actionCrud !== "create") {
        _item.id = item.id;
    }

    try {
        let response = {};
        if (actionCrud === "create") {
            response = await axiosClient.post(`${urlBackendUsuarios}${epName}`, _item, {
                headers: { "Access-Control-Allow-Origin": "*" },
            });
        } else if (actionCrud === "update") {
            console.log("actualizando indice...", _item);
            response = await axiosClient.put(`${urlBackendUsuarios}${epName}`, _item, {
                headers: { "Access-Control-Allow-Origin": "*" },
            });
        } else if (actionCrud === "disable" || actionCrud === "enable") {

            response = await axiosClient.delete(`${urlBackendUsuarios}${epName}`, {
                params: {
                    id: _item.id,
                    username_actualiza: item.usernameUsuarioActualiza,
                    action: actionCrud,
                },
                headers: { "Access-Control-Allow-Origin": "*" },
            });
        }

        if (response.status === 200) {
            let _error = "error_code" in response.data;
            if (!_error) {
                // si no hay error controlado
                response.ok = true;
                response.messageText =
                    `${nameItemText}` +
                    (actionCrud === "disable"
                        ? itemGender === "M"
                            ? " deshabilitado"
                            : " deshabilitada"
                        : actionCrud === "enable"
                            ? itemGender === "M"
                                ? " habilitado"
                                : " habilitada"
                            : itemGender === "M"
                                ? " guardado"
                                : " guardada");
                response.messageSeverity = "success";
            } else {
                // si hay error controlado
                console.log(_errorMessage);
                console.log(response);

                let _message_code = response.data.message_code;
                if (_message_code === "err-Indice-already-exist") {
                    response.messageText = `Ya existe ${unUna} ${nameItemText} con esa descripción`;
                } else {
                    response.messageText = _errorMessage;
                }
                response.ok = false;
                response.messageSeverity = "error";
            }
            return response;
        }
    } catch (error) {
        console.log(_errorMessage);
        if (error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            console.log(error.response);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log(error);
        }
        let response = {};
        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "error";
        return response;
    }
};

const getHistorialIndiceByEndpoint = async (params, endpoint) => {
    console.log("getHistorialIndice params:", params, `${urlBackendUsuarios}${endpoint}`);
    let _errorMessage = `Se produjo un error al obtener ${elLa} ${nameItemText}`;

    try {
        const response = await axiosClient.get(`${urlBackendUsuarios}${endpoint}`, {
            params: params,
            headers: {
                "Access-Control-Allow-Origin": "*",
            },
        });

        if (response.status === 200) {
            let _error = "error_code" in response.data;
            if (!_error) {
                // si no hay error controlado
                response.ok = true;
                return response;
            }
        }

        // si hay algun error controlado

        console.log(_errorMessage);
        console.log(response);

        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "error";
        return response;
    } catch (error) {
        console.log(_errorMessage);
        if (error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            console.log(error.response);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log(error);
        }
        let response = {};
        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "error";
        return response;
    }
};

export const getHistorialIndice = async (params) => getHistorialIndiceByEndpoint(params, epHistorialName);

export const getHistorialIndiceCompleto = async (params) => getHistorialIndiceByEndpoint(params, epHistorialCompletoName);

export const getFuentes = async (params) => {
    let _errorMessage = "Se produjo un error al obtener Fuentes";
    try {
        const response = await axiosClient.get(`${urlBackendUsuarios}${epFuenteName}`, {
            params,
            headers: { "Access-Control-Allow-Origin": "*" },
        });

        if (response.status === 200 && !("error_code" in response.data)) {
            response.ok = true;
            return response;
        }

        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "error";
        return response;
    } catch (error) {
        console.log(_errorMessage);
        console.log(error?.response || error?.request || error);
        return {
            ok: false,
            messageText: _errorMessage,
            messageSeverity: "error",
        };
    }
};

export const createFuente = async (item) => {
    let _errorMessage = "No fue posible crear la Fuente";
    try {
        const response = await axiosClient.post(`${urlBackendUsuarios}${epFuenteName}`, item, {
            headers: { "Access-Control-Allow-Origin": "*" },
        });

        if (response.status === 200 && !("error_code" in response.data)) {
            response.ok = true;
            response.messageText = "Fuente guardada";
            response.messageSeverity = "success";
            return response;
        }

        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "error";
        return response;
    } catch (error) {
        console.log(_errorMessage);
        console.log(error?.response || error?.request || error);
        return {
            ok: false,
            messageText: _errorMessage,
            messageSeverity: "error",
        };
    }
};

export const getTiposValor = async (params) => {
    let _errorMessage = "Se produjo un error al obtener Tipos de Valor";
    try {
        const response = await axiosClient.get(`${urlBackendUsuarios}${epTipoValorName}`, {
            params,
            headers: { "Access-Control-Allow-Origin": "*" },
        });

        if (response.status === 200 && !("error_code" in response.data)) {
            response.ok = true;
            return response;
        }

        response.ok = false;
        response.messageText = _errorMessage;
        response.messageSeverity = "error";
        return response;
    } catch (error) {
        console.log(_errorMessage);
        console.log(error?.response || error?.request || error);
        return {
            ok: false,
            messageText: _errorMessage,
            messageSeverity: "error",
        };
    }
};